// Module
var code = "<div> <div class=\"mishion_history\"> <div class=\"mission_title\">Checkout List</div> </div> <div class=\"clearfix\"></div> <div class=\"col-xs-12\"> <parts-checked-out-grid parts=\"ctrl.parts\"> </parts-checked-out-grid> </div> </div>";
// Exports
var _module_exports = code;;
var path = 'parts/Pages/checkedOut/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;